import React, { useEffect, useState } from "react";
import bloodSampleIcon from "src/assets/images/blood-sample-ye.png";
import biomarkerIcon from "src/assets/images/biomarker-ye.png";
import resultIcon from "src/assets/images/result-estimated-yellow-icon.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus, faMinus, faStar } from "@fortawesome/free-solid-svg-icons";
import AddCartComponent from "./AddCartComponent";
import httpRequest from "src/helpers/httpRequest";
import { toast } from "react-toastify";
import FavoriteCoponent from "src/Components/GlobalComponents/FavoriteCoponent";
import ShareComponent from "src/Components/GlobalComponents/ShareComponent";
import { capitalize, Skeleton } from "@mui/material";
import BoxWrapper from "src/Components/WebsiteComponents/BoxWrapper";
import HowManytDealOFF from "src/Components/GlobalComponents/HowManytDealOFF";
import { CURRENCY } from "src/lib/constans";
import { removeAllDisLike } from "src/Store/disLike";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "src/Store/store";

interface IObj {
  _id: string;
  productName: string;
  description: string;
  testTypeId: string;
  resultDays: number;
  regularPrice: number;
  salePrice: number;
  linksId: string[];
  testInstuction: {
    instructionDetail: string;
    _id: string;
  }[];
  qna: {
    question: string;
    answer: string;
    _id: string;
  }[];
  productImage: string;
  isPrescriptionRequired: boolean;
  adminRefId: string;
  createdAt: string; // ISO Date string
  updatedAt: string; // ISO Date string
  __v: number;
  prescriptionRequired: boolean;
  status: boolean;
  categoriesId: string[];
  isLiked: boolean;
  biomarkers: {
    id: string;
    name: string;
  }[];
  testType: string;
  noOfBiomarkers: number;
  [key: string]: any;
}

const DProductDetails: React.FC<{
  id: string;
  setName?: (val: string) => void;
}> = ({ id = "", setName = () => {} }) => {
  const [faqsOpen, setFaqsOpen] = useState<string[]>([]);
  const [isLoader, setIsLoader] = useState<boolean>(true);
  const [item, setItem] = useState<IObj | null>(null);
  const { testsDisLike } = useSelector((state: RootState) => state.disLike);
  const dispatch = useDispatch<AppDispatch>();
  const handleToogle = (id: string) => {
    setFaqsOpen((prev) =>
      prev?.includes(id) ? prev?.filter((v) => v !== id) : [...prev, id]
    );
  };

  const fetch = async () => {
    setIsLoader(true);
    const { res, err } = await httpRequest<IObj>({
      path: `/product/single/${id}`,
    });
    if (res) {
      setItem(res || null);
      setName(res?.productName || "");
      dispatch(removeAllDisLike("testsDisLike"));
    } else {
      toast(err, { type: "error" });
    }
    setIsLoader(false);
  };

  useEffect(() => {
    if (id) {
      fetch();
    }
  }, [id]);

  useEffect(() => {
    if (testsDisLike.length > 0) {
      let updatedStatusData = {
        ...item,
        isLiked: testsDisLike.find((i) => i === item?._id)
          ? false
          : item?.isLiked,
      }
      setItem(updatedStatusData as IObj);
      dispatch(removeAllDisLike("testsDisLike"));
    }
  }, [testsDisLike]);

  return (
    <>
      <div className="grid grid-cols-1 md:grid-cols-[4fr,8fr] gap-3">
        {isLoader ? (
          <Skeleton
            variant="rectangular"
            width="100%"
            height="100%"
            className="rounded-md xl:rounded-lg aspect-square"
          />
        ) : (
          <div className="w-full relative border border-gray-300 flex items-center justify-center rounded-lg overflow-hidden aspect-square">
            <HowManytDealOFF
              salePrice={item?.salePrice || 0}
              regularPrice={item?.regularPrice || 0}
              detailsUI={true}
            />
            <div className="absolute top-3 right-3 flex items-center gap-2 flex-col">
              <FavoriteCoponent
                id={item?._id || "dummy"}
                liked={item?.isLiked}
                // onLikeProduct={(id, isLiked) => {
                //   setItem({
                //     ...item,
                //     isLiked: isLiked,
                //   } as IObj);
                // }}
                category="tests"
              />
              <ShareComponent
                shareText={`${capitalize(
                  item?.brandName || ""
                )} - Product Id is ${item?._id}`}
                shareTitle={`${capitalize(item?.productName || "")}`}
              />
            </div>
            <img
              src={`${item?.productImage}`}
              alt={item?.name || ""}
              className="w-full h-full object-cover"
            />
          </div>
        )}
        <div className="flex flex-col gap-6">
          <div className="flex  flex-row  items-start justify-between">
            {isLoader ? (
              <div className="w-full">
                <Skeleton
                  variant="text"
                  width={"50%"}
                  height={"2vw"}
                  className="rounded-md min-w-[200px] max-w-[90%] min-h-5"
                />
                <Skeleton
                  variant="text"
                  width={"45%"}
                  height={"2vw"}
                  className="rounded-md min-w-[200px] max-w-[90%] min-h-5"
                />
              </div>
            ) : (
              <p
                title={item?.productName}
                className="font-Lexend-Regular break-all !text-[#393939] line-clamp-1 leading-tight text-[25px]"
              >
                {item?.productName}
              </p>
            )}

            {item?.prescriptionRequired ? (
              <span className="Prescription-requird-inner-span text-white font-Poppins-Regular font-size-12px">
                Prescription Required
              </span>
            ) : (
              <span></span>
            )}
          </div>
          <div className="text-yellow-400 mb-3 text-[15px] 2xl:text-[20px] flex flex-row reviewstars items-center">
            {isLoader ? (
              <Skeleton
                variant="text"
                width={"20%"}
                height={"1.8vw"}
                className="rounded-md min-w-[200px] max-w-[90%] min-h-5"
              />
            ) : (
              [1, 2, 3, 4, 5].map((v) => (
                <FontAwesomeIcon
                  key={v}
                  className={
                    (item?.averageRating || 0) >= v
                      ? "text-[#facc15] mr-0.5"
                      : "text-[#b7b6b1] mr-0.5"
                  }
                  icon={faStar}
                />
              ))
            )}
            {isLoader ? (
              <Skeleton
                variant="text"
                width={"20%"}
                height={"1.8vw"}
                className="rounded-md ml-2 min-w-[200px] max-w-[90%] min-h-5"
              />
            ) : (
              <span className="text-[#707070] font-Poppins-Regular font-size-16px -mb-1 ml-2">
                {item?.averageRating ? item?.averageRating.toFixed(1) : "0.0"} -{" "}
                {item?.ratingsCount
                  ? item?.ratingsCount.toString().padStart(2, "0")
                  : "0"}{" "}
                Reviews
              </span>
            )}
          </div>
          <div className="diagostic-product-detail-activity">
            <div className="diagostic-product-detail-include">
              {isLoader ? (
                <Skeleton
                  variant="rectangular"
                  width={"1.5vw"}
                  height={"1.5vw"}
                  className="rounded-md aspect-square min-w-[25px] min-h-[25px]"
                />
              ) : (
                <img src={bloodSampleIcon} alt="" />
              )}
              {isLoader ? (
                <Skeleton
                  variant="text"
                  width={"30%"}
                  height={"1.8vw"}
                  className="rounded-md min-w-[100px] max-w-[90%] min-h-5"
                />
              ) : (
                <span className="text-[#707070] font-size-15px font-Poppins-Regular">
                  {item?.testType || ""}
                </span>
              )}
            </div>
            <div className="diagostic-product-detail-include">
              {isLoader ? (
                <Skeleton
                  variant="rectangular"
                  width={"1.5vw"}
                  height={"1.5vw"}
                  className="rounded-md aspect-square min-w-[25px] min-h-[25px]"
                />
              ) : (
                <img src={biomarkerIcon} alt="" />
              )}
              {isLoader ? (
                <Skeleton
                  variant="text"
                  width={"30%"}
                  height={"1.8vw"}
                  className="rounded-md min-w-[100px] max-w-[90%] min-h-5"
                />
              ) : (
                <span className="text-[#707070] font-size-15px font-Poppins-Regular">{`${
                  item?.noOfBiomarkers || ""
                } Biomarkers`}</span>
              )}
            </div>
          </div>
          <div className="diagostic-product-detail-include">
            {isLoader ? (
              <Skeleton
                variant="rectangular"
                width={"1.5vw"}
                height={"1.5vw"}
                className="rounded-md aspect-square min-w-[25px] min-h-[25px]"
              />
            ) : (
              <img src={resultIcon} alt="" />
            )}
            {isLoader ? (
              <Skeleton
                variant="text"
                width={"30%"}
                height={"1.8vw"}
                className="rounded-md min-w-[100px] max-w-[90%] min-h-5"
              />
            ) : (
              <span className="text-[#707070] font-size-15px font-Poppins-Regular">{`Results estimated in ${item?.resultDays} working days`}</span>
            )}
          </div>
          {isLoader ? (
            <Skeleton
              variant="text"
              width={"15%"}
              height={"2.4vw"}
              className="rounded-md min-w-[100px] max-w-[90%] min-h-6"
            />
          ) : (
            <div className="flex gap-4 items-center w-fit">
              <span className="text-[#202020] font-Poppins-SemiBold  font-size-26px">
                {CURRENCY} {item?.salePrice || item?.regularPrice}
              </span>
              {item?.salePrice != null && item?.salePrice > 0 && (
                <span className="text-[#434343] line-through font-Poppins-Regular font-size-19px">
                  {CURRENCY} {item?.regularPrice || ""}
                </span>
              )}
            </div>
          )}
          {isLoader ? (
            <div className="flex flex-col">
              <Skeleton
                variant="text"
                width={"60%"}
                height={"1.8vw"}
                className="rounded-md min-w-[200px] max-w-[90%] min-h-5"
              />
              <Skeleton
                variant="text"
                width={"40%"}
                height={"1.8vw"}
                className="rounded-md min-w-[200px] max-w-[90%] min-h-5"
              />
            </div>
          ) : (
            <p
              title={item?.description}
              className="font-Lexend-Regular diagostic-product-detail-des text-[#707070] font-size-15px line-clamp-3"
            >
              {item?.description}
            </p>
          )}
          {isLoader ? (
            <Skeleton
              variant="rectangular"
              width={"15%"}
              height={"2.4vw"}
              className="rounded-full min-w-[120px] max-w-[90%] min-h-5"
            />
          ) : (
            <AddCartComponent
              textBtn={true}
              productId={item?._id || ""}
              type="diagnostic"
              prescriptionRequired={item?.prescriptionRequired || false}
              quantity={1}
              itemType="product"
              btnStyle={{
                width: "fit-content",
                paddingLeft: "40px",
                paddingRight: "40px",
              }}
            />
          )}
        </div>
      </div>
      <BoxWrapper
        title="Biomarkers Included"
        productDetailBoxDesign
        loading={isLoader}
      >
        <div className="flex gap-4 flex-wrap">
          {isLoader ? (
            <Skeleton
              variant="text"
              width={"50%"}
              height={"1.8vw"}
              className="rounded-md min-w-[200px] max-w-[90%] min-h-5"
            />
          ) : (
            item?.biomarkers?.map((v) => (
              <p
                key={v?.id}
                className=" w-fit border border-gray-500 rounded-md px-3 py-1 text-[#707070] font-size-18px font-Lexend-Regular "
              >
                {v?.name || ""}
              </p>
            ))
          )}
        </div>
      </BoxWrapper>
      <BoxWrapper
        title="Test Instructions"
        productDetailBoxDesign
        loading={isLoader}
      >
        <div className="flex flex-col gap-3">
          {isLoader ? (
            <Skeleton
              variant="text"
              width={"50%"}
              height={"1.8vw"}
              className="rounded-md min-w-[200px] max-w-[90%] min-h-5"
            />
          ) : (
            item?.testInstuction?.map((v) => (
              <div
                key={v?._id}
                className="product-detail-biomarker-included-test-inst-inner"
              >
                <strong></strong>
                <p className="text-[#707070] font-size-18px font-Lexend-Regular">
                  {v?.instructionDetail || ""}
                </p>
              </div>
            ))
          )}
        </div>
      </BoxWrapper>
      <BoxWrapper
        title="FAQs"
        titleClass="!pt-0 !px-0 xl:px-0 font-size-20px "
        className="p-2 xl:p-4"
        productDetailBoxDesign
        viewContainerClass="!p-0 !xl:p-0"
        darkTitleBorder
        loading={isLoader}
      >
        {isLoader ? (
          <Skeleton
            variant="text"
            width={"50%"}
            height={"1.8vw"}
            className="rounded-md min-w-[200px] max-w-[90%] min-h-5"
          />
        ) : (
          item?.qna?.map((v, index) => (
            <div
              key={v?._id}
              className="product-detail-faqs-main"
              onClick={() => handleToogle(v?._id)}
              id={`faq-${index + 1}`}
            >
              <div className="product-detail-faqs">
                <span className="text-[#707070] font-size-18px font-Lexend-Regular">
                  {v?.question}
                </span>
                <FontAwesomeIcon
                  className="font-size-20px text-[#707070]"
                  icon={faqsOpen?.includes(v?._id) ? faMinus : faPlus}
                />
              </div>
              {faqsOpen?.includes(v?._id) ? (
                <div className="faq-content">
                  <p className="text-[#B8B6B6] font-size-18px font-Poppins-Regular">
                    {v?.answer}
                  </p>
                </div>
              ) : null}
            </div>
          ))
        )}
      </BoxWrapper>
    </>
  );
};

export default DProductDetails;
